import { Component, inject } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { QuoteService } from '../../../../core/services/quote.service';

@Component({
  selector: 'app-cotizar',
  standalone: true,
  imports: [NgIf, NgFor],
  templateUrl: './cotizar.component.html',
  styleUrl: './cotizar.component.scss'
})
export class CotizarComponent {
  q = inject(QuoteService);
}
